import React, { PropTypes } from 'react';
import Paper from 'material-ui/Paper'
import Dialog from 'material-ui/Dialog';
import AppBar from 'material-ui/AppBar';
import {ListItem, List} from 'material-ui/List';
import ErrorContainer from '../../form/ErrorContainer';
import IconClose from '../../Icons/IconClose';
import IconButton from 'material-ui/IconButton';


import ProductGridList from '../ProductGridList';

class ProductSelect extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.object,
    disabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  state = {
    displayModal: false
  };

  chooseProduct = (item) => {
    this.props.onChange(item);
    this.closeSelectModal();
  };

  closeSelectModal = () => {
    this.setState({displayModal: false});
    this.props.onBlur();
  };

  showSelectModal = () => {
    this.setState({displayModal: true});
    this.props.onFocus();
  };

  render() {
    let {label, value, disabled} = this.props;
    let {displayModal} = this.state;

    let modalAppBar = (<AppBar
      style={{padding: '0 16px'}}
      title='Select a promotion item'
      iconStyleLeft={{display: 'none'}}
      iconElementLeft={null}
      iconElementRight={
        <IconButton onClick={this.closeSelectModal}><IconClose /></IconButton>
      }
    />);

    return (
      <ErrorContainer label={label} {...this.props}>
        <Paper onClick={() => !disabled && this.showSelectModal()}>
          {
            value
              ? this._renderSelectedItem(value)
              : this._renderEmptyItem()
          }
        </Paper>
        <Dialog
          title={modalAppBar}
          modal={false}
          open={displayModal}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >

          <ProductGridList onSelect={this.chooseProduct}/>
        </Dialog>
      </ErrorContainer>
    );
  }

  _renderSelectedItem(item) {
    let {disabled} = this.props;
    return (
      <List>
        <ListItem
          disabled={disabled}
          primaryText={item.name}
        />
      </List>
    );
  }

  _renderEmptyItem() {
    return (
      <List>
        <ListItem
          primaryText='Choose the product for promotion'
        />
      </List>
    );
  }
}

export default ProductSelect;



// WEBPACK FOOTER //
// ./src/components/Shop/ProductSelect/ProductSelect.jsx